import React, { useEffect, useState } from 'react'
import { Form, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import MaterialInput from '../../../common/MaterialInput'
import Dialog from '../../../common/Dialog'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import validateZipcode from '../../../../utils/validateZipcode'
import MedcareOrMedcaidCheckDialog from '../MedcareOrMedicaidCheckDialog/MedcareOrMedicaidCheckDialog'
import { getIsHmoMember } from '../../../../utils/hmoUtils'

import './useCouponDialogue.css'

const UseCouponDialogue = props => {
  const { isCouponDialogVisible, setIsCouponDialogVisible, plan } = props
  const {
    invalidCouponErrorMessage,
    couponData,
    selectedPlan,
    isApplyCouponCodeLoading,
    isCouponSkipStripeAddressUpdateLoading,
    isCouponSkipStripeAddressUpdateErrorMessage,
    skipCheckoutPage,
  } = useSelector(state => state.payment)

  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const [locationValues, setLocationValues] = useState()
  const dialogActions = []
  const { resetFields } = form
  const userDetails = useSelector(state => state.profile?.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const [finishFlowSkipCheckout, setFinishFlowSkipCheckout] = useState(false)

  useEffect(() => {
    if (skipCheckoutPage) {
      // if we are in hmo , finish flow without showing location details
      if (isHmoMember) {
        dispatch(
          Actions.createAction(
            Actions.IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_RECEIVED
          )
        )
      }
    } else {
      resetFields(['couponCode'])
      setIsCouponDialogVisible()
    }
    if (finishFlowSkipCheckout) {
      handelSkipCheckout()
    }
  }, [skipCheckoutPage, finishFlowSkipCheckout])

  const handleOk = () => {
    setIsCouponDialogVisible()
  }

  const onAbort = e => {
    setIsCouponDialogVisible()
  }

  const getAppliedCoupon = () => {
    const coupon = couponData.find(eachCoupon => eachCoupon.id === plan.id)
    return coupon ? coupon : null
  }

  const handleOnContinueCouponCode = value => {
    dispatch(
      Actions.createAction(Actions.IS_COUPON_VALID_REQUESTED, {
        customerCoupon: value.couponCode,
        selectedPlan: plan,
      })
    )
  }

  const handleUserDetails = values => {
    setLocationValues(values)
    setIsCouponDialogVisible()
    if (isHmoMember) {
      setFinishFlowSkipCheckout(true)
      handelSkipCheckout()
    } else {
      dispatch(Actions.createAction(Actions.REQUEST_MEDICARE_DIALOG))
    }
  }

  const validateZipCodeField = (rule, value, callback) => {
    const isValidZipCode = !!validateZipcode(value)
    if (isValidZipCode) {
      callback()
    } else {
      callback(
        $t('pages.getStarted.useCouponDialogue.errors.pleaseEnterAValidZipcode')
      )
    }
  }

  const renderValidCouponFields = () => {
    return (
      <Form
        onFinish={handleUserDetails}
        name="basic"
        className="use-coupon-form"
        initialValues={{
          homeAddress: '',
          city: '',
          zipcode: '',
        }}
        form={form}
      >
        <h2 className="free-coupon-description">
          {$t('pages.getStarted.useCouponDialogue.freeCouponDescription')}
        </h2>
        <Form.Item
          className="coupon-form-item"
          name={'homeAddress'}
          type="text"
          rules={[
            {
              required: true,
              message: $t(
                'pages.getStarted.useCouponDialogue.errors.requiredField'
              ),
            },
          ]}
        >
          <MaterialInput
            label={$t('pages.getStarted.useCouponDialogue.homeAddress')}
          />
        </Form.Item>
        <Form.Item
          className="coupon-form-item"
          name={'city'}
          type="text"
          rules={[
            {
              required: true,
              message: $t(
                'pages.getStarted.useCouponDialogue.errors.requiredField'
              ),
            },
          ]}
        >
          <MaterialInput
            label={$t('pages.getStarted.useCouponDialogue.city')}
          />
        </Form.Item>
        <Form.Item
          className="coupon-form-item"
          name={'zipcode'}
          type="text"
          rules={[
            {
              validator: validateZipCodeField,
            },
          ]}
        >
          <MaterialInput
            label={$t('pages.getStarted.useCouponDialogue.zipCode')}
          />
        </Form.Item>
        <Form.Item>
          <Button
            className="use-coupon-user-details-continue-button"
            type="primary"
            loading={isCouponSkipStripeAddressUpdateLoading}
            htmlType="submit"
          >
            {$t('pages.getStarted.useCouponDialogue.continue')}
          </Button>
        </Form.Item>
        <div className="invalid-coupon-error-message">
          {isCouponSkipStripeAddressUpdateErrorMessage}
        </div>
      </Form>
    )
  }

  const renderCouponCodeField = () => {
    return (
      <Form
        onFinish={handleOnContinueCouponCode}
        name="basic"
        className="use-coupon-form"
        initialValues={{
          couponCode: '',
        }}
        form={form}
      >
        <div className="enter-coupon-container">
          <Form.Item
            className="enter-coupon-form-item"
            name={'couponCode'}
            type="text"
          >
            <MaterialInput
              label={$t('pages.getStarted.useCouponDialogue.enterCoupon')}
            />
          </Form.Item>
          {invalidCouponErrorMessage &&
          selectedPlan &&
          plan.id === selectedPlan.id ? (
            <div className="invalid-coupon-error-message">
              {invalidCouponErrorMessage}
            </div>
          ) : null}
        </div>
        <Form.Item>
          <Button
            className="coupon-details-continue-button"
            htmlType="submit"
            type="primary"
            loading={isApplyCouponCodeLoading ? true : false}
          >
            {$t('pages.getStarted.useCouponDialogue.continue')}
          </Button>
        </Form.Item>
      </Form>
    )
  }

  const renderForms = () => {
    if (skipCheckoutPage && !isHmoMember) {
      return renderValidCouponFields()
    }
    return renderCouponCodeField()
  }

  const onCancel = () => {
    resetFields(['couponCode'])
    setIsCouponDialogVisible()
    dispatch(
      Actions.createAction(Actions.COUPON_DIALOGUE_CANCEL_BUTTON_PRESSED)
    )
  }
  const handleMedcaidSubmit = () => {
    handelSkipCheckout()
    dispatch(Actions.createAction(Actions.REQUEST_CLOSE_MEDICARE_DIALOG))
  }

  const handelSkipCheckout = () => {
    dispatch(
      Actions.createAction(
        Actions.IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_REQUESTED,
        {
          address: locationValues.homeAddress,
          city: locationValues.city,
          zipcode: locationValues.zipcode,
          state: validateZipcode(locationValues.zipcode),
        }
      )
    )
  }

  return (
    <Dialog
      isVisible={isCouponDialogVisible}
      footerActions={dialogActions}
      onCancel={onCancel}
      onOk={handleOk}
      onAbort={onAbort}
      title={$t('pages.getStarted.useCouponDialogue.useCoupon')}
      className="use-coupon-code-dialogue"
    >
      <div className="use-coupon-code-dialogue-container">{renderForms()}</div>
      {!isHmoMember && (
        <MedcareOrMedcaidCheckDialog handleSubmit={handleMedcaidSubmit} />
      )}
    </Dialog>
  )
}

export default UseCouponDialogue
